import {formatPriceNumber} from 'core/helpers';
import {IProduct} from 'modules/product-card/models/ProductResponse';
import {useMemo} from 'react';

export const useProductResultPrice = (product?: IProduct | null) => {
    return useMemo(() => {
        if (!product) {
            return '';
        }

        const {discount, specPrice} = product.price;

        return formatPriceNumber(specPrice ? specPrice : discount.price);
    }, [product]);
};
